import { CustomerResultAddress } from 'type/address';

export interface ConfigCountry {
  code: string;
  dialCode: string;
  isDefault?: boolean;
  name: string;
}

export const mapCustomerAddress = (
  address: CustomerResultAddress | undefined,
  countryList: ConfigCountry[],
): CustomerResultAddress | undefined => {
  if (!address) {
    return undefined;
  }

  const countryName = countryList.find((country) => country.code === address.country)?.name;

  return countryName ? { ...address, countryName } : { ...address };
};
